import styled from 'styled-components';

export const ShrinkContent = styled.div`
  flex-shrink: 1;
  overflow-y: hidden;
  height: 100%;
`;

export const ShrinkContentColumn = styled.div`
  max-height: 100%;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  &:last-child {
    flex-shrink: 1;
  }
`;
